import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { useRegister, type registerResponse200 } from "@/api";
import { RegisterCredentialTemplate } from "@/components/Templates";
import { getErrorMessage } from "@/lib/api/errors";
import { registerFormSchema, type RegisterFormValues } from "@/lib/validation/auth.schemas";
import { useLoginPrefillStore } from "@/stores/loginPrefill.store";

export function RegisterPage() {
  const navigate = useNavigate();
  const setPrefill = useLoginPrefillStore((state) => state.setPrefill);

  const [serverError, setServerError] = useState<string | null>(null);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterFormValues>({
    resolver: zodResolver(registerFormSchema),
    defaultValues: {
      username: "",
      phone: "",
      password: "",
      repeate_password: "",
      acceptTerms: false,
    },
  });

  const { mutate: registerUser, isPending } = useRegister<registerResponse200>({
    mutation: {
      onSuccess: (res, variables) => {
        if (res.status !== 200) return;
        setPrefill({
          phone: variables.data.phone,
          password: variables.data.password,
        });
        navigate({ to: "/login" });
      },
      onError: (error) => setServerError(getErrorMessage(error, "ثبت‌نام انجام نشد؛ دوباره تلاش کنید")),
    },
  });

  const onSubmit = ({ username, phone, password, repeate_password }: RegisterFormValues) => {
    setServerError(null);
    registerUser({ data: { username, phone, password, repeate_password } });
  };

  return (
    <RegisterCredentialTemplate
      register={register}
      control={control}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      errors={errors}
      isPending={isPending}
      serverError={serverError}
    />
  );
}
